import { Injectable } from '@angular/core';
import { AngularWaitBarrier } from 'blocking-proxy/built/lib/angular_wait_barrier';
import { Http, URLSearchParams, Headers } from '@angular/http';
import 'rxjs/Rx';
import { URL_SERVICIOS } from '../../conf/url.servicios';
import { Router } from '@angular/router';

@Injectable()
export class ResportesAdminService {

  constructor(private router: Router, public http: Http) { }
  ventas: any = [];
}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/services/resportes-admin.service.ts